import { animate, group, query, stagger, style, transition, trigger } from '@angular/animations';
import { Location } from '@angular/common';
import { AfterViewChecked, AnimationTransitionEvent, Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { KenticoClassName } from '../../models/kentico-class-name.enum';
import { Answer, Modal, AnswerConfirmation } from '../../models/qa.model';
import { HistoryService } from '../../services/history.service';
import { QaService } from '../../services/qa.service';
import { StartupService } from '../../services/startup.service';
import { forEach } from '@angular/router/src/utils/collection';
import { AnswerInfoService } from '../../services/answer-info.service';
import { WoodTypeEnum } from '../../models/wood-type';
import { QuestionTypeEnum } from '../../models/question-type';
import { VisualizerService } from '../../services/visualizer.service';
import { Color } from '../../models/color.model';

@Component({
  selector: 'app-answer-confirmation',
  templateUrl: './answer-confirmation.component.html',
  styleUrls: ['./answer-confirmation.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition('* => in', [
        query('.animate-item', style({ transform: 'translateX(600px)', opacity: 0 })),
        query('.animate-item', stagger('50ms', group([
          animate('200ms cubic-bezier(0.55, 0.055, 0.675, 0.19)', style({ opacity: 1 })),
          animate('300ms cubic-bezier(.02, .01, .47, 1)', style({ transform: 'translateX(0)' }))
        ]))),
      ]),
      transition('* => out', [
        query('.animate-item', style({ transform: 'translateX(0)', opacity: 1 })),
        query('.animate-item', stagger('50ms', group([
          animate('200ms cubic-bezier(0.55, 0.055, 0.675, 0.19)', style({ opacity: 0 })),
          animate('300ms cubic-bezier(.02, .01, .47, 1)', style({ transform: 'translateX(-600px)' }))
        ]))),
      ])
    ])
  ]
})

export class AnswerConfirmationComponent implements OnInit, AfterViewChecked, OnDestroy {
  animationState: string= 'in';
  modals: Modal[];
  answerConfirmation: AnswerConfirmation;

  constructor(public startupService: StartupService,
    public qaService: QaService,
    private router: Router,
    private route: ActivatedRoute,
    private elementRef: ElementRef,
    private historyService: HistoryService,
    private location: Location,
    private answerInfoService: AnswerInfoService,
    private visualizerService: VisualizerService
  ) { }


  ngOnInit() {
    this.route.params.subscribe(params => {
      const nodeId = params['nodeId'] === null ? 0 : params['nodeId'];
      const answerConfirmationId = params['answerConfirmationId'] === null ? 0 : params['answerConfirmationId'];

      this.answerConfirmation = this.startupService.startupData.AnswerConfirmations.find(x => x.NodeId === answerConfirmationId);
    });

    this.animationState = 'in';
    this.prepareModals();

    // TODO: Figure out non-path product pages
    if (this.qaService.CurrentAnswer != null &&
      this.answerInfoService.getQuestionTypeGuid(QuestionTypeEnum.WoodType) === this.qaService.CurrentAnswer.QuestionType
    ) {

      this.qaService.answers.selectedColor = new Color();
      this.qaService.answers.selectedColor.Opacity = 'd6828d21-e4f1-4829-9a23-b59b1495736d';
      this.qaService.answers.selectedColor.Name = 'CLEAR';
    }

    // Not ideal but quick fix for last minute requirement
    if (this.qaService.CurrentAnswer != null &&
      this.answerInfoService.getQuestionTypeGuid(QuestionTypeEnum.WoodCondition) === this.qaService.CurrentAnswer.QuestionType
    ) {
      if (this.qaService.getProject() === 'deck') {
        this.answerConfirmation.Description = this.answerConfirmation.Description.replace(/\[variable\]/, 'resurfacer');
      } else {
        this.answerConfirmation.Description = this.answerConfirmation.Description.replace(/\[variable\]/, 'solid');
      }
    }
  }

  private prepareModals() {
    this.modals = new Array<Modal>();
    this.answerConfirmation.ModalIds.forEach((id) => {
      const modal = this.startupService.startupData.Modals.find(m => m.NodeId === id.toString());
      this.modals.push(new Modal(modal));
    });
  }

  ngAfterViewChecked() {
    const componentContext = this;
    const anchors = componentContext.elementRef.nativeElement.querySelector('p.description').children;
    for (let i = 0; i < anchors.length; i++) {
      if (anchors[i].localName === 'a') {
        anchors[i].addEventListener('click',
          e => {
            const value = e.currentTarget.getAttribute('href');
            if (value.indexOf('~') >= 0) {
              e.preventDefault();
              componentContext.modals.find(modal => {
                return modal.NodeId === value.substring(1, value.length);
              }).HideModal = false;
              componentContext.modals.find(modal => {
                return modal.NodeId === value.substring(1, value.length);
              }).modalStatus(false);
            }
          });
      }
    }
  }

  animationEnd(event: AnimationTransitionEvent) {
    if (event.toState === 'out') {
      if (this.answerConfirmation.NextActionClassName === KenticoClassName.Visualizer) {
        this.router.navigate(this.startupService.getVisualizerRouterLink());
        return;
      }
      if (this.answerConfirmation.NextActionClassName === KenticoClassName.Product) {
        this.router.navigate(this.startupService.getProductRouterLink(this.qaService.CurrentAnswer.ProductNodeAlias));
        return;
      }
      this.router.navigate(this.startupService.getStepWithNodeRouterLink(this.answerConfirmation.LinkedActionNodeId));
    }
  }

  nextStep() {
    this.animationState = 'out';
  }

  ngOnDestroy() {
    this.qaService.setAnimationState('out');
    this.qaService.CurrentAnswer = null;
  }
}





// WEBPACK FOOTER //
// ./src/app/components/answer-confirmation/answer-confirmation.component.ts